import { render, staticRenderFns } from "./goodsItem.vue?vue&type=template&id=3605f5d5&"
import script from "./goodsItem.vue?vue&type=script&lang=js&"
export * from "./goodsItem.vue?vue&type=script&lang=js&"
import style0 from "./goodsItem.vue?vue&type=style&index=0&id=3605f5d5&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3605f5d5')) {
      api.createRecord('3605f5d5', component.options)
    } else {
      api.reload('3605f5d5', component.options)
    }
    module.hot.accept("./goodsItem.vue?vue&type=template&id=3605f5d5&", function () {
      api.rerender('3605f5d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/renovation/Modules/goodsItem.vue"
export default component.exports